import type { SvgIconName } from '@/types'

const svgModules = import.meta.glob<string>('../assets/**/*.svg', {
  query: '?raw',
  import: 'default'
})

const svgPromises = new Map<SvgIconName, Promise<string>>()
// 按名称找文件 按需加载
export function getSvgContent(name: SvgIconName): Promise<string> {
  const cached = svgPromises.get(name)
  if (cached) return cached

  const loader = svgModules[`../assets/${name}`]
  if (!loader) return Promise.resolve('')

  const content = loader()
  svgPromises.set(name, content)
  return content
}

export function getAvailableIcons(): string[] {
  return Object.keys(svgModules).map((path) => path.replace('../assets/', ''))
}
